export const tr = {
    'set-context-price': 'Yeni ve değiştirilmiş gösterim koşulları için bin gösterim başına maksimum teklif'
};
